import { SingleFeedbackChipWithSourceRunAction } from '@/components/FeedbackChips';
import ThumbsDownIcon from '@/icons/ThumbsDownIcon.svg?react';
import ThumbsUpIcon from '@/icons/ThumbsUpIcon.svg?react';
import { FeedbackStatsFieldValues } from '@/types/schema';
import { cn } from '@/utils/tailwind';

import { determineComparisonStatus } from './utils';

interface PairwiseFeedbackChipProps {
  feedbackKey: string;
  feedbackField?: FeedbackStatsFieldValues;
  maxCategories: number;
  runId?: string;
  datasetShareToken?: string;
  exampleId: string;
  columnId: string;
  pairwiseNonBaseline: string | undefined;
  feedbackDeltas?: Record<
    string,
    { improved_examples: string[]; regressed_examples: string[] }
  >;
}

export function PairwiseFeedbackChip({
  feedbackKey,
  feedbackField,
  maxCategories,
  exampleId,
  columnId,
  pairwiseNonBaseline,
  feedbackDeltas,
  runId,
  datasetShareToken,
}: PairwiseFeedbackChipProps) {
  const { isImprovement, isRegression } = determineComparisonStatus(
    exampleId,
    columnId,
    pairwiseNonBaseline,
    feedbackDeltas
  );

  const getChipStyle = () => {
    if (isImprovement) {
      return 'border border-success bg-success-secondary text-success';
    }
    if (isRegression) {
      return 'border border-error bg-error-secondary text-error';
    }
    return 'border border-brand bg-brand-secondary text-brand-primary';
  };

  const getDecorator = () => {
    if (isImprovement) {
      return <ThumbsUpIcon className="h-4 w-4 text-success" />;
    }
    if (isRegression) {
      return <ThumbsDownIcon className="h-4 w-4 text-error" />;
    }
    return <div className="-ml-2" />;
  };

  const { avg, values, show_feedback_arrow } = feedbackField ?? {};
  return (
    <div className="flex">
      <SingleFeedbackChipWithSourceRunAction
        feedbackKey={feedbackKey}
        avg={avg}
        values={values}
        showFeedbackArrow={show_feedback_arrow}
        maxNumberOfCategories={maxCategories}
        allowTruncation
        className={cn('rounded-full', getChipStyle())}
        feedbackSourceRunId={datasetShareToken ? undefined : runId}
        startDecorator={getDecorator()}
        disablePopover={!!datasetShareToken}
      />
    </div>
  );
}
